import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { FileboxOperationEnum } from '../enums/filebox-operation.enum';
import { FileboxStatusEnum } from '../enums/filebox-status.enum';

/**
 * Filebox filters
 */
export class FileboxFilters extends ApiRequestFilters {
	/**
	 * Tenant IDs
	 */
	tenants?: number[];

	/**
	 * User IDs
	 */
	users?: number[];

	/**
	 * Filebox item operation values
	 */
	operations?: FileboxOperationEnum[];

	/**
	 * Filebox item status values
	 */
	statuses?: FileboxStatusEnum[];
}
